// DEPRECATED

console.warn(`WARNING: Package 'rcm-i18n' is deprecated, please use '@rcm/i18n-client'`);

export {default as default} from '@rcm/i18n-client';
export * from '@rcm/i18n-client';
